import { ICON_PATH } from '@federa/const/icon-svg-paths';
import { createIcon } from '../createIcon.tsx';

export const DownloadIcon = createIcon(
	'DownloadIcon',
	<>
		<path d={ICON_PATH.TRAY_OPEN_TOP} />
		<polyline points="7 10 12 15 17 10" />
		<line x1="12" y1="15" x2="12" y2="3" />
	</>,
);
